import { useState, useEffect } from "react";
import {  useParams } from "react-router-dom";
import "./AdvisoryManagement.scss";
import "../../styles/global.scss";

// React Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
// @ts-ignore
import Cookies from "js-cookie";

import { AdvisoryManagementTableColumns } from "../components/TableMUI/TableColumns";
import Sidebar from "../components/sidebar/Sidebar";

import { AdvisoryManagementTableDTO } from "../dtos/advisory.dtos";
import { GetUserProfile } from "../../API/endpoints/User";
import Navbar from "../components/header/NavBar";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../API/endpoints/RolesAndPermissions/Roles";
import { Breadcrumb,  } from "antd";
import AdvisoryList from "./components/AdvisoryList";
import { USER_TYPE_PARTNER } from "../../constants/constants";

function AdvisoryManagement() {
  const [usertype, setUsertype] = useState<string | undefined>("");
  const [orgID, setOrgID] = useState<string | undefined>("");
  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [dataRestriction, setDataRestriction] = useState(false);
  const [roleID, setRoleID] = useState<string | undefined>("");
  const [permissions, setPermissions] = useState<any>([]);


  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          setOrgID(response.data?.organization?.id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID]);

  useEffect(() => {
    if (roleID) {
      (async () => {
        const roleDetails = await GetRoleById(roleID.toString());
        setDataRestriction(roleDetails?.data?.data_restriction);

        if (roleDetails?.data?.type === "organization") {
          setUsertype("brand");
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "11"
          );
          setPermissions(response?.data);
        } else if (roleDetails?.data?.type === "administrative") {
          setUsertype("admin");

          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "6"
          );
          setPermissions(response?.data);
        }
      })();
    }
  }, [roleID]);



  return (
    <Container fluid className="adminusers">
      <Row className="row">
        <Col className="sidebar">
          <Sidebar active="advisory" />
        </Col>
        <Col className="adminusers-content p-0 bg-[#F2F4F7]">
          <Navbar userProfile={userProfile} />
          <div className="bg-white px-[24px] pt-[8px] pb-[4px]">
            <Breadcrumb
              items={[
                {
                  title: 'ADVISORY MANAGEMENT',

                }
              ]}
            />
          </div>
          <div className="h-[calc(100vh-80px)]">
            <AdvisoryList
              userType={usertype}
            />
          </div>

        </Col>
      </Row>

    </Container>
  );
}

export default AdvisoryManagement;
